// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"97":"49ce7ff9","297":"f00cf132","950":"f8196372"}[chunkId] + ".js";
};